import * as domainConstants from "../../constants/DomainConstants";
import showToastr from "../../util/toastr.js";
import redirector from "../../util/redirector.js";
import { getStore } from "../../store/configureStore";

export default class IndienenPageHelper {
    constructor(context, redirector) {
        this.dispatch = getStore().dispatch;
        this.context = context;
        this.redirector = redirector;
    }

    init() {
        const dossierId = this.context.props.params.dossierId;
        this.context.props.loadIndienen(dossierId)
            .then(isIngediend => {
                if (isIngediend)
                    redirector.goTo("/indienen/bevestiging");
            });

        this.context.props.getContent(dossierId, "dossierPDF")
            .then(result => {
                if (result.success) {
                    const pdfFiles = result.data.length > 0 && result.data[1].files.length > 0 ? result.data[1] : null;
                    if (pdfFiles) {
                        this.context.setState(
                            {
                                pdf: pdfFiles
                            });
                    }
                }
            });
    }

    unmount() {
        this.handleOnStopInterval();
    }

    update(nextProps) {
        if (this.context.props.indienen !== nextProps.indienen) {
            const dossierId = this.context.props.params.dossierId;
            const indienen = nextProps.indienen;
            this.context.props.loadLayout(dossierId, indienen.dossierNaam, indienen.tabTitle, indienen.initialisatieOK, indienen.typeDossier, nextProps.infrastructuurId, indienen.redenVanStatus && (indienen.redenVanStatus.toString() != domainConstants.REDEN_VAN_STATUS_INGEDIEND.toString()));
        }
    }

    onSave(event) {
        event.preventDefault();
        this.context.props.confirmIndienen(this.context.props.indienen.dossierId)
            .then(isIngediend => {
                if (isIngediend) {
                    redirector.goTo("/indienen/bevestiging");
                }
            });
    }

    handleOnStartInterval() {
        this.context.setState({ pollCount: 0 });
        const timer = setInterval(() => {
            if (this.context.state.pollCount > 19) {
                this.handleOnStopInterval();
            }
            this.context.props.getContent(this.context.props.indienen.dossierId, "dossierPDF")
                .then(result => {
                    if (result.success) {
                        const pdfFiles = result.data.length > 0 && result.data[1].files.length > 0 ? result.data[1] : null;
                        if (pdfFiles) {
                            this.context.setState(
                                {
                                    pdf: pdfFiles
                                });
                            this.handleOnStopInterval();
                        }
                    }
                    this.context.setState({ pollCount: this.context.state.pollCount + 1 });
                });
        }, 10000);

        this.context.setState({ timer: timer });
    }

    handleOnStopInterval() {
        this.context.props.loadIndienen(this.context.props.params.dossierId);
        clearInterval(this.context.state.timer);
        this.context.setState({ timer: null });
    }

    onGeneratePdf() {
        this.context.props.generatePdf(this.context.props.params.dossierId).then(success => {
            if (success) {
                showToastr(domainConstants.PDF_GENEREREN);
                this.handleOnStartInterval();
            }
        });
    }
}